import { ReactNode } from 'react';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider
} from 'react-router-dom';
import { LoginScreen } from '@/screens/auth/LoginScreen';
import { VerifyScreen } from '@/screens/auth/VerifyScreen';
import { MainLayout } from '@/layouts/MainLayout';
import { AccountScreen } from '@/screens/account/AccountScreen';
import { KeysScreen } from '@/screens/keys/KeysScreen';
import { UsageScreen } from '@/screens/usage/UsageScreen';
import { WebhookScreen } from '@/screens/webhook/WebhookScreen';
import { QuickstartScreen } from '@/screens/quickstart/QuickstartScreen';
import { TrustScreen } from '@/screens/trust/TrustScreen';
import { useAuthStore } from '@/store/authStore';

function RequireAuth({ children }: { children: ReactNode }) {
  const token = useAuthStore(s => s.token);
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function RedirectIfAuthed({ children }: { children: ReactNode }) {
  const token = useAuthStore(s => s.token);
  if (token) return <Navigate to="/account" replace />;
  return <>{children}</>;
}

const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <RedirectIfAuthed>
        <LoginScreen />
      </RedirectIfAuthed>
    )
  },
  {
    path: '/auth/verify',
    element: <VerifyScreen />
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <MainLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/account" replace /> },
      { path: 'account', element: <AccountScreen /> },
      { path: 'keys', element: <KeysScreen /> },
      { path: 'usage', element: <UsageScreen /> },
      { path: 'webhook', element: <WebhookScreen /> },
      { path: 'quickstart', element: <QuickstartScreen /> },
      { path: 'trust', element: <TrustScreen /> }
    ]
  },
  { path: '*', element: <Navigate to="/account" replace /> }
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
